module.exports = __webpack_public_path__ + "img/10.8bf7ee21.jpg";